import React, { useEffect } from "react";
import { Ul, Button, LiA } from "./style.js";
import { useDispatch, useSelector } from "react-redux";
import { fetchAuth, fetchLogout } from "../../../Actions/userAction";
import CartButton from "../CartButton/index";
import PropTypes from "prop-types";

export default function BurgerNav({ open }) {
    const { isLogin, User } = useSelector((state) => state.user);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchAuth());
    }, []);

    const onClick = () => {
        dispatch(fetchLogout());
    };

    return (
        <Ul open={open}>
            <li>
                {isLogin ? (
                    <Button onClick={onClick}>Logout</Button>
                ) : (
                    <Button to="/login">Login</Button>
                )}
            </li>
            <li>
                <LiA to="/">Home</LiA>
            </li>
            <li>
                <LiA to="/product">Product</LiA>
            </li>
            <li>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                    }}
                >
                    {isLogin ? (
                        <>
                            <h1>{User.name}</h1> <CartButton />
                        </>
                    ) : (
                        <CartButton />
                    )}
                </div>
            </li>
        </Ul>
    );
}

BurgerNav.propTypes = {
    open:PropTypes.bool
};
